// Modules
import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

// Components
import { LayoutContent, Spinner } from '@/ui';
import { StyledLayout } from './AuthLayoutStyles';

const AuthLayout = () => {
  return (
    <StyledLayout>
      <LayoutContent>
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      </LayoutContent>
    </StyledLayout>
  );
};

export default AuthLayout;
